import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_btn_sort_icon",
  "use": "lc_btn_sort_icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_btn_sort_icon\"><path d=\"M897.146 658.265 557.454 303.474 557.845 303.065 512 256 466.148 303.065 466.543 303.477 126.854 658.265 172.699 705.337 511.997 350.952 851.294 705.337Z\" p-id=\"6191\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol